















import { Component, Vue } from 'vue-property-decorator';
import DashboardCoreAppBar from '@/components/dashboard/shared/AppBar.vue';
import DashboardCoreAppDrawer from '@/components/dashboard/shared/Drawer.vue';

@Component({
    components: {
        DashboardCoreAppBar,
        DashboardCoreAppDrawer
    }
})
export default class Dashboard extends Vue
{
    private items: any[] = [];

    public expandOnHover: boolean = false;
}
